import React from 'react';
import './DeleteConfirmationModal.css';

function DeleteConfirmationModal({ isOpen, onClose, onConfirm, characterName, isDeleting }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <div className="modal-container delete-confirmation-modal">
        <div className="modal-header">
          <h3>Delete Character</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>

        <div className="modal-body">
          <div className="warning-icon">⚠️</div>
          <p className="warning-text">
            Are you sure you want to delete <strong>{characterName}</strong>?
          </p>
          <p className="warning-subtext">
            This action cannot be undone. All character data, including stats, skills, and abilities will be permanently deleted.
          </p>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Character'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;
